import * as i0 from '@angular/core';
import * as i1 from './rebirth-ng.module';
import * as i2 from './common/auto-focus.directive';
import * as i3 from './common/template-loader.component';
import * as i4 from './common/resizeable.directive';
import * as i5 from './common/dropdown.directive';
import * as i6 from './modal/modal-backdrop.component';
import * as i7 from './pager/pager.component';
import * as i8 from './pagination/pagination.component';
import * as i9 from './alert-box/alert-box.component';
import * as i10 from './badge/badge.component';
import * as i11 from './panel/panel.component';
import * as i12 from './panel/panel-header.component';
import * as i13 from './panel/panel-body.component';
import * as i14 from './panel/panel-footer.component';
import * as i15 from './accordion/accordion.component';
import * as i16 from './action-button/action-button.component';
import * as i17 from './rating/rating.component';
import * as i18 from './tabs/tabs.component';
import * as i19 from './tabs/tab.component';
import * as i20 from './tabs/tab-title.directive';
import * as i21 from './tabs/tab-content.directive';
import * as i22 from './tooltip/tooltip.directive';
import * as i23 from './tooltip/tooltip-popup.component';
import * as i24 from './popover/popover.directive';
import * as i25 from './date-picker/date-picker.directive';
import * as i26 from './date-picker/date-picker-popup.component';
import * as i27 from './breadcrumbs/breadcrumbs.component';
import * as i28 from './progress-bar/progress-bar.component';
import * as i29 from './select-button/select-button.component';
import * as i30 from './overlay/overlay.component';
import * as i31 from './carousel/carousel.component';
import * as i32 from './carousel/slide.directive';
import * as i33 from './switch/switch.component';
import * as i34 from './menu-bar/menu-bar.component';
import * as i35 from './auto-complete/auto-complete.directive';
import * as i36 from './auto-complete/auto-complete-popup.component';
import * as i37 from './auto-complete/hightlight.component';
import * as i38 from './auto-complete/mutiple-auto-complete.component';
import * as i39 from './flow-step/flow-step.component';
import * as i40 from './infinite-scroll/infinite-scroll.component';
import * as i41 from './file-upload/file-upload.component';
import * as i42 from './file-upload/file-upload-preview.component';
import * as i43 from './time-picker/time-picker.component';
import * as i44 from './radio-group/radio-group.component';
import * as i45 from './checkbox-group/checkbox-group.component';
import * as i46 from './checkbox-group/checkbox.component';
import * as i47 from './validators/rebirth-validators.directive';
import * as i48 from './notify/notify.component';
import * as i49 from './tree-view/tree-view.component';
import * as i50 from './tree-view/tree-node.component';
import * as i51 from './tree-view/tree-panel.component';
import * as i52 from './ellipsis/ellipsis.component';
import * as i53 from './tags/tags.component';
import * as i54 from './image-upload/image-upload.component';
import * as i55 from './image-upload/view-image-modal.component';
import * as i56 from './select/select.component';
import * as i57 from './slider/slider.component';
import * as i58 from './common/trust-html.pipe';
import * as i59 from './common/date.pipe';
import * as i60 from './common/common.module';
import * as i61 from './modal/modal.module';
import * as i62 from './dialog/dialog.module';
import * as i63 from './pager/pager.module';
import * as i64 from './pagination/pagination.module';
import * as i65 from './alert-box/alert-box.module';
import * as i66 from './badge/badge.module';
import * as i67 from './panel/panel.module';
import * as i68 from './accordion/accordion.module';
import * as i69 from './action-button/action-button.module';
import * as i70 from './rating/rating.module';
import * as i71 from './tabs/tabs.module';
import * as i72 from './tooltip/tooltip.module';
import * as i73 from './popover/popover.module';
import * as i74 from './date-picker/date-picker.module';
import * as i75 from './breadcrumbs/breadcrumbs.module';
import * as i76 from './progress-bar/progress-bar.module';
import * as i77 from './select-button/select-button.module';
import * as i78 from './overlay/overlay.module';
import * as i79 from './carousel/carousel.module';
import * as i80 from './switch/switch.module';
import * as i81 from './menu-bar/menu-bar.module';
import * as i82 from './auto-complete/auto-complete.module';
import * as i83 from './flow-step/flow-step.module';
import * as i84 from './infinite-scroll/infinite-scroll.module';
import * as i85 from './file-upload/file-upload.module';
import * as i86 from './time-picker/time-picker.module';
import * as i87 from './radio-group/radio-group.module';
import * as i88 from './checkbox-group/checkbox-group.module';
import * as i89 from './validators/rebirth-validators.module';
import * as i90 from './notify/notify.module';
import * as i91 from './tree-view/tree-view.module';
import * as i92 from './ellipsis/ellipsis.module';
import * as i93 from './tags/tags.module';
import * as i94 from './image-upload/image-upload.module';
import * as i95 from './select/select.module';
import * as i96 from './slider/slider.module';
import * as i97 from './draggable/draggable.module';
export const RebirthNGModuleNgFactory:i0.NgModuleFactory<i1.RebirthNGModule> = (null as any);
var _decl0_0:i2.AutoFocusDirective = (<any>(null as any));
var _decl0_1:i3.TemplateLoaderComponent = (<any>(null as any));
var _decl0_2:i4.ResizeableDirective = (<any>(null as any));
var _decl0_3:i5.DropdownDirective = (<any>(null as any));
var _decl0_4:i6.ModalBackdropComponent = (<any>(null as any));
var _decl0_5:i7.PagerComponent = (<any>(null as any));
var _decl0_6:i8.PaginationComponent = (<any>(null as any));
var _decl0_7:i9.AlertBoxComponent = (<any>(null as any));
var _decl0_8:i10.BadgeComponent = (<any>(null as any));
var _decl0_9:i11.PanelComponent = (<any>(null as any));
var _decl0_10:i12.PanelHeaderComponent = (<any>(null as any));
var _decl0_11:i13.PanelBodyComponent = (<any>(null as any));
var _decl0_12:i14.PanelFooterComponent = (<any>(null as any));
var _decl0_13:i15.AccordionComponent = (<any>(null as any));
var _decl0_14:i16.ActionButtonComponent = (<any>(null as any));
var _decl0_15:i17.RatingComponent = (<any>(null as any));
var _decl0_16:i18.TabsComponent = (<any>(null as any));
var _decl0_17:i19.TabComponent = (<any>(null as any));
var _decl0_18:i20.TabTitleDirective = (<any>(null as any));
var _decl0_19:i21.TabContentDirective = (<any>(null as any));
var _decl0_20:i22.TooltipDirective = (<any>(null as any));
var _decl0_21:i23.TooltipPopupComponent = (<any>(null as any));
var _decl0_22:i24.PopoverDirective = (<any>(null as any));
var _decl0_23:i25.DatePickerDirective = (<any>(null as any));
var _decl0_24:i26.DatePickerPopupComponent = (<any>(null as any));
var _decl0_25:i27.BreadcrumbsComponent = (<any>(null as any));
var _decl0_26:i28.ProgressBarComponent = (<any>(null as any));
var _decl0_27:i29.SelectButtonComponent = (<any>(null as any));
var _decl0_28:i30.OverlayComponent = (<any>(null as any));
var _decl0_29:i31.CarouselComponent = (<any>(null as any));
var _decl0_30:i32.SlideDirective = (<any>(null as any));
var _decl0_31:i33.SwitchComponent = (<any>(null as any));
var _decl0_32:i34.MenuBarComponent = (<any>(null as any));
var _decl0_33:i35.AutoCompleteDirective = (<any>(null as any));
var _decl0_34:i36.AutoCompletePopupComponent = (<any>(null as any));
var _decl0_35:i37.HightlightComponent = (<any>(null as any));
var _decl0_36:i38.MutipleAutoCompleteComponent = (<any>(null as any));
var _decl0_37:i39.FlowStepComponent = (<any>(null as any));
var _decl0_38:i40.InfiniteScrollComponent = (<any>(null as any));
var _decl0_39:i41.FileUploadComponent = (<any>(null as any));
var _decl0_40:i42.FileUploadPreviewComponent = (<any>(null as any));
var _decl0_41:i43.TimePickerComponent = (<any>(null as any));
var _decl0_42:i44.RadioGroupComponent = (<any>(null as any));
var _decl0_43:i45.CheckboxGroupComponent = (<any>(null as any));
var _decl0_44:i46.CheckboxComponent = (<any>(null as any));
var _decl0_45:i47.RequiredWithTrimDirective = (<any>(null as any));
var _decl0_46:i47.RangeLengthDirective = (<any>(null as any));
var _decl0_47:i47.MinDirective = (<any>(null as any));
var _decl0_48:i47.RangeDirective = (<any>(null as any));
var _decl0_49:i47.MaxDirective = (<any>(null as any));
var _decl0_50:i47.DigitsDirective = (<any>(null as any));
var _decl0_51:i47.NumberDirective = (<any>(null as any));
var _decl0_52:i47.UrlDirective = (<any>(null as any));
var _decl0_53:i47.EmailDirective = (<any>(null as any));
var _decl0_54:i47.DateDirective = (<any>(null as any));
var _decl0_55:i47.DateISODirective = (<any>(null as any));
var _decl0_56:i47.JsonDirective = (<any>(null as any));
var _decl0_57:i47.Base64Directive = (<any>(null as any));
var _decl0_58:i47.PhoneDirective = (<any>(null as any));
var _decl0_59:i47.UUIDDirective = (<any>(null as any));
var _decl0_60:i47.EqualDirective = (<any>(null as any));
var _decl0_61:i47.IncludesDirective = (<any>(null as any));
var _decl0_62:i47.EqualToDirective = (<any>(null as any));
var _decl0_63:i47.BeforeDateDirective = (<any>(null as any));
var _decl0_64:i47.AfterDateDirective = (<any>(null as any));
var _decl0_65:i48.NotifyComponent = (<any>(null as any));
var _decl0_66:i49.TreeViewComponent = (<any>(null as any));
var _decl0_67:i50.TreeNodeComponent = (<any>(null as any));
var _decl0_68:i51.TreePanelComponent = (<any>(null as any));
var _decl0_69:i52.EllipsisComponent = (<any>(null as any));
var _decl0_70:i53.TagsComponent = (<any>(null as any));
var _decl0_71:i54.ImageUploadComponent = (<any>(null as any));
var _decl0_72:i55.ViewImageModalComponent = (<any>(null as any));
var _decl0_73:i56.SelectComponent = (<any>(null as any));
var _decl0_74:i57.SliderComponent = (<any>(null as any));
var _decl0_75:i58.TrustHtmlPipe = (<any>(null as any));
var _decl0_76:i59.DatePipe = (<any>(null as any));
var _decl0_114:i60.RebirthCommonModule = (<any>(null as any));
var _decl0_115:i61.ModalModule = (<any>(null as any));
var _decl0_116:i62.DialogModule = (<any>(null as any));
var _decl0_117:i63.PagerModule = (<any>(null as any));
var _decl0_118:i64.PaginationModule = (<any>(null as any));
var _decl0_119:i65.AlertBoxModule = (<any>(null as any));
var _decl0_120:i66.BadgeModule = (<any>(null as any));
var _decl0_121:i67.PanelModule = (<any>(null as any));
var _decl0_122:i68.AccordionModule = (<any>(null as any));
var _decl0_123:i69.ActionButtonModule = (<any>(null as any));
var _decl0_124:i70.RatingModule = (<any>(null as any));
var _decl0_125:i71.TabsModule = (<any>(null as any));
var _decl0_126:i72.TooltipModule = (<any>(null as any));
var _decl0_127:i73.PopoverModule = (<any>(null as any));
var _decl0_128:i74.DatePickerModule = (<any>(null as any));
var _decl0_129:i75.BreadcrumbsModule = (<any>(null as any));
var _decl0_130:i76.ProgressBarModule = (<any>(null as any));
var _decl0_131:i77.SelectButtonModule = (<any>(null as any));
var _decl0_132:i78.OverlayModule = (<any>(null as any));
var _decl0_133:i79.CarouselModule = (<any>(null as any));
var _decl0_134:i80.SwitchModule = (<any>(null as any));
var _decl0_135:i81.MenuBarModule = (<any>(null as any));
var _decl0_136:i82.AutoCompleteModule = (<any>(null as any));
var _decl0_137:i83.FlowStepModule = (<any>(null as any));
var _decl0_138:i84.InfiniteScrollModule = (<any>(null as any));
var _decl0_140:i85.FileUploadModule = (<any>(null as any));
var _decl0_141:i86.TimePickerModule = (<any>(null as any));
var _decl0_142:i87.RadioGroupModule = (<any>(null as any));
var _decl0_143:i88.CheckboxGroupModule = (<any>(null as any));
var _decl0_144:i89.RebirthValidatorsModule = (<any>(null as any));
var _decl0_145:i90.NotifyModule = (<any>(null as any));
var _decl0_146:i91.TreeViewModule = (<any>(null as any));
var _decl0_147:i92.EllipsisModule = (<any>(null as any));
var _decl0_148:i93.TagsModule = (<any>(null as any));
var _decl0_149:i94.ImageUploadModule = (<any>(null as any));
var _decl0_150:i95.SelectModule = (<any>(null as any));
var _decl0_151:i96.SliderModule = (<any>(null as any));
var _decl0_139:i97.DraggableModule = (<any>(null as any));
var _decl0_152:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_153:i0.ElementRef<any> = (<any>(null as any));
